export enum AudioPermission {
  'PENDING',
  'GRANTED',
  'DENIED'
}
